import {Component, Inject, OnInit} from '@angular/core';
import {FormControl, FormGroup, Validators} from '@angular/forms';
import {Response, StaticMethods} from '../../model/GeneralModels';
import {ActivatedRoute, Router} from '@angular/router';
import {AuthService} from '../../services/auth.service';
import {GeneralService} from '../../services/general.service';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: [
    './login.component.css',
    '../../assets/css/light.theme.css'
  ]
})
export class LoginComponent implements OnInit {
  mobile = '';
  mobileMode = true;
  returnURL: string;
  code: number;
  role: string;
  loginForm = new FormGroup({
    mobile: new FormControl('',
      [
        Validators.required,
        Validators.maxLength(11),
        Validators.minLength(11),
      ])
  });
  timeLeft = 0;
  interval: any;
  codeSubmissionForm = new FormGroup({
    securityCode: new FormControl('',
      [Validators.required, Validators.maxLength(5), Validators.minLength(5)])
  });
  imageClass: string;
  backUrl: string;

  constructor(
    private service: GeneralService,
    private route: ActivatedRoute,
    private router: Router,
    private authService: AuthService
  ) {
  }

  ngOnInit() {
    this.authService.logout();
    this.role = history.state.role || StaticMethods.getRole(this.router.url);
    console.log(this.route.snapshot.queryParams.returnUrl);
    this.returnURL = this.route.snapshot.queryParams.returnUrl || '/';
    this.imageClass = this.returnURL.includes('mobile') ? 'card-heading-mobile' : this.returnURL.includes('accidents') ?
      'card-heading-accidents' : '';
    this.backUrl = this.route.snapshot.queryParams.backUrl ? this.route.snapshot.queryParams.backUrl : '';
  }

  getCode() {
    if (this.loginForm.valid) {
      console.log(this.loginForm.value);
      this.service.getCode(this.loginForm.controls.mobile.value, this.role).subscribe((response: Response) => {
        console.log(response);
        if (response.success) {
          this.mobileMode = false;
          this.setTimer(120);
        }
      });
    }
  }

  submitCode() {
    if (this.codeSubmissionForm.valid) {
      this.service.loginUser(
        this.codeSubmissionForm.controls.securityCode.value,
        this.loginForm.controls.mobile.value,
        this.role
      ).subscribe((response: Response) => {
        if (response.success) {
          console.log(this.loginForm.controls.mobile.value);
          this.authService.encode(this.loginForm.controls.mobile.value, this.role);
          this.mobile = this.loginForm.controls.mobile.value;
          this.stopTimer();
          StaticMethods.showMessage('با موفقیت انجام شد');
          this.router.navigate([this.returnURL], {state: history.state});
        }
      });
    }
  }

  setTimer(seconds) {
    this.timeLeft = seconds;
    this.interval = setInterval(() => {
      if (this.timeLeft > 0) {
        this.timeLeft--;
      }
    }, 1000);
  }

  stopTimer() {
    clearInterval(this.interval);
  }

  resendCode() {
    this.stopTimer();
    this.mobileMode = true;
  }

  onNoClick(): void {
    // this.dialogRef.close();
  }

}
